'use client'

import Box from '@mui/material/Box'

import DownloadGuide from '@/components/DownloadGuide'
import GenericHero from '@/components/Hero/GenericHero'
import InteractiveCheckout from '@/components/InteractiveCheckout/InteractiveCheckout'
import LearnMoreTiles from '@/components/LearnMoreTiles'
import PlugInAndGo from '@/components/PlugInAndGo'
import ProjectFunnel from '@/components/ProjectFunnel/ProjectFunnel'
import RequestDemo, { Sector } from '@/components/RequestDemo'
import PaymentsLogos from '@/sections/PaymentsLogos'
import TrueLayerCustomerQuote from '@/sections/TrueLayerCustomerQuote'
import { HUBSPOT_FORM_IDS } from '@/utills/constants'

export default function Page() {
    return (
        <>
            <Box>
                <GenericHero
                    chips={{
                        items: [
                            {
                                src: '/images/heros/chip-payments-1.png',
                                width: 480,
                                height: 96,
                            },
                            {
                                src: '/images/heros/chip-payments-2.png',
                                width: 480,
                                height: 96,
                            },
                            {
                                src: '/images/heros/chip-payments-3.png',
                                width: 480,
                                height: 96,
                            },
                            {
                                src: '/images/heros/chip-payments-4.png',
                                width: 480,
                                height: 96,
                            },
                        ],
                        gap: 6,
                    }}
                    backgroundImageMobile={'/images/heros/payments-mobile.png'}
                    title={'Change for a better world: embed climate action into every payment'}
                    description={
                        <>
                            Accelerate revenue by integrating the only API that combines emissions
                            calculations with climate contributions.
                            <br /> <br />
                            Educate and empower consumers to take immediate action.
                        </>
                    }
                />
                <PaymentsLogos />
            </Box>
            {/* TODO: Add hrefs to Learn More tiles */}
            <LearnMoreTiles
                tiles={[
                    {
                        title: 'Green checkout',
                        description:
                            'Empower merchants to create a green checkout experience as unique as their business.',
                        icon: '/icons/icon-green-checkout.png',
                        scrollToSection: 'checkout',
                    },
                    {
                        title: 'Vetted climate projects',
                        description:
                            'Boost customer loyalty by helping your clients reach their sustainability objectives with vetted climate projects.',
                        icon: '/icons/icon-climate-projects.png',
                        scrollToSection: 'projects-funnel',
                    },
                    {
                        title: 'Plug in and go',
                        description:
                            'Secure immediate results via  API integration or spreadsheet upload.',
                        icon: '/icons/icon-plug-in.png',
                        scrollToSection: 'plug-in-and-go',
                    },
                ]}
            />
            <TrueLayerCustomerQuote />
            <Box id={'checkout'}>
                <InteractiveCheckout />
            </Box>
            <Box id={'projects-funnel'}>
                <ProjectFunnel />
            </Box>
            <DownloadGuide hubspotFormId={HUBSPOT_FORM_IDS.greenForm} />
            <Box id={'plug-in-and-go'}>
                <PlugInAndGo
                    items={[
                        {
                            backgroundImageUrl: '/illustrations/plug-in-and-go/api-green.png',
                            title: 'Seamless API integration',
                            description:
                                'Lune customers integrate our API in 1–2 weeks with support from our engineers.',
                        },
                        {
                            backgroundImageUrl: '/illustrations/plug-in-and-go/offsetting.png',
                            title: 'Hosted carbon offsetting page',
                            description:
                                'No coding, no integration, no accounting required. Take payments for carbon credits without processing the finances via Lune Pay.',
                        },
                    ]}
                />
            </Box>
            <RequestDemo sector={Sector.PAYMENTS} />
        </>
    )
}
